import React from 'react';
import CuesheetStore from 'flux/stores/cuesheet/CuesheetStore';
import {
  ColumnWidths,
  ColumnWidthStrings,
  ColumnWidthClassNames,
  EditableCellTypes,
  DefaultColumnWidth,
  ItemColumnHeaderTitle,
  DescriptionColumnHeaderTitle,
  NoteColumnHeaderTitle,
  PlaceholderTitleRowItemSegment,
} from 'flux/stores/cuesheet/CuesheetConstants';
import CuesheetHelper from 'flux/helpers/cuesheetHelper';
import CuesheetCursorActions from 'flux/actions/cuesheet/CuesheetCursorActions';
import UserSessionStore from 'flux/stores/UserSessionStore';
import PopoverStore from 'flux/stores/PopoverStore';
import EventViewStore from 'flux/stores/EventViewStore';
import DataHeaderCell from 'main/components/show/grid/columnHeaderCell/dataColumnCell.jsx';
import UtilityHeaderCell from 'main/components/show/grid/columnHeaderCell/utilityColumnCell.jsx';
import ItemHeaderCell from 'main/components/show/grid/columnHeaderCell/itemColumnCell.jsx';
import DescriptionHeaderCell from 'main/components/show/grid/columnHeaderCell/descriptionColumnCell.jsx';
import NoteHeaderCell from 'main/components/show/grid/columnHeaderCell/noteColumnCell.jsx';
import DataCell from 'main/components/show/cuesheet/dataCell.jsx';
import Duration from 'main/components/show/cuesheet/duration.jsx';
import PresetDuration from 'main/components/show/cuesheet/presetDuration.jsx';
import StartTime from 'main/components/show/cuesheet/startTime.jsx';
import ItemTitle from 'main/components/show/cuesheet/itemCell/segment.jsx';
import NoteCell from 'main/components/show/cuesheet/noteCell.jsx';
import ItemDescription from 'main/components/show/cuesheet/itemCell/description.jsx';
import ItemSelectionState from 'main/components/show/cuesheet/itemCell/selectionState.jsx';
import RowMenuBar from 'main/components/show/cuesheet/itemCell/rowMenuBar.jsx';
import ItemLock from 'main/components/show/cuesheet/itemCell/lock.jsx';
import NavigationMixin from 'main/components/show/cuesheet/navigationMixin';
import HotKeyMixin from 'main/components/show/cuesheet/hotKeyMixin';
import ItemCellNumber from 'main/components/show/cuesheet/itemCell/number.jsx';
import Reflux from 'reflux';
import keyIn from 'shared/lib/immutable/keyIn';
import capitalize from 'underscore.string/capitalize';
import AddColumnButton from 'main/components/show/cuesheet/addColumnButton.jsx';
import AddItemButton from 'main/components/show/cuesheet/addItemButton.jsx';
import classNames from 'classnames';
import CuesheetMixin from 'main/components/show/cuesheet/cuesheetMixin';
import CuesheetPopulateMixin from 'main/components/show/cuesheet/cuesheetPopulateMixin.js';
import HighlightCellMixin from 'main/components/show/cuesheet/highlightCellMixin';
import Spinner from 'shared/components/misc/simpleSpinner.jsx';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import { DisplayTypes } from 'shared/constants/FlowConstants';
import TimeDisplayTypes from 'shared/constants/TimeDisplayTypes';
import CuesheetActions from 'flux/actions/cuesheet/CuesheetActions';
import {
  getDataCellWidthName,
  getNoteCellWidthName,
  getItemTitleCellWidthName,
  getItemDescriptionCellWidthName,
} from '../cuesheet/rowWidthHelper';

const UtilColumnWidths = {
  ItemNumber: 45,
  StartTime: 120,
  Duration: 105,
  PresetDuration: 115,
  Description: 120,
  Title: 120,
  Note: 120,
};

/**
 * Holy shit! Grid (Schedules and Lists) :)
 */
export default React.createClass({
  displayName: 'ShowGrid',

  mixins: [
    Reflux.ListenerMixin,
    Reflux.connect(CuesheetStore, 'cuesheet'),
    Reflux.connect(UserSessionStore, 'user'),
    Reflux.connectFilter(PopoverStore, 'popoverVisible', (st) =>
      st.find((val) => val),
    ),
    Reflux.connectFilter(EventViewStore, 'event', (st) =>
      st.filter(keyIn('twentyFourHourClock', 'timeZone', '_id', 'team')),
    ),
    NavigationMixin,
    HotKeyMixin,
    CuesheetMixin,
    CuesheetPopulateMixin,
    PureRenderMixin,
  ],

  componentWillMount() {
    CuesheetActions.setCopyStateFromSession();
  },

  componentDidUpdate(prevProps, prevState) {
    const curState = this._getCuesheetState();
    const selectedCellMovementDirection = curState.get(
      'selectedCellMovementDirection',
    );
    const scrollToSelectedCell = curState.get('scrollToSelectedCell');

    const selectedCellNodes = document.body.querySelectorAll(
      '.cs-cell-selected',
    );
    let selectedCellNode = null;

    if (selectedCellNodes.length === 1) {
      selectedCellNode = selectedCellNodes[0];
    }

    if (selectedCellNodes.length > 1) {
      if (
        selectedCellMovementDirection === 'up' ||
        selectedCellMovementDirection === 'left'
      ) {
        selectedCellNode = selectedCellNodes[0];
      } else if (
        selectedCellMovementDirection === 'down' ||
        selectedCellMovementDirection === 'right'
      ) {
        selectedCellNode = selectedCellNodes[selectedCellNodes.length - 1];
      }

      // For search
      if (
        scrollToSelectedCell &&
        scrollToSelectedCell !== prevState.cuesheet.get('scrollToSelectedCell')
      ) {
        selectedCellNode =
          selectedCellNodes.length > 0 ? selectedCellNodes[0] : null;
      }
    }

    if (selectedCellNode) {
      const scrollOptions = { behavior: 'instant' };

      if (selectedCellMovementDirection === 'up') scrollOptions.block = 'start';
      if (selectedCellMovementDirection === 'down') scrollOptions.block = 'end';
      if (selectedCellMovementDirection === 'left')
        scrollOptions.inline = 'start';
      if (selectedCellMovementDirection === 'right')
        scrollOptions.inline = 'end';

      if (!scrollOptions.inline) scrollOptions.inline = 'nearest';
      if (!scrollOptions.block) scrollOptions.block = 'nearest';

      // Get cell node position in the viewport
      const bounding = selectedCellNode.getBoundingClientRect();

      if (
        bounding.top < 0 ||
        bounding.left < 0 ||
        bounding.right >
          (window.innerWidth || document.documentElement.clientWidth) ||
        bounding.bottom >
          (window.innerHeight || document.documentElement.clientHeight)
      ) {
        selectedCellNode.scrollIntoView(scrollOptions);
      }

      if (scrollToSelectedCell)
        CuesheetCursorActions.deleteScrollToSelectedCell();
    }
  },

  render() {
    const state = this._getCuesheetState(),
      rows = state.get('rows');

    const displayType = state.getIn(['show', 'displayType']);
    const gridClasses = 'grid ' + displayType;

    let contentNode = <Spinner top="50%" left="50%" />;

    const loadFailureNode = this.getLoadFailureNode();
    if (loadFailureNode) contentNode = loadFailureNode;

    if (rows && rows.size && !state.get('loading')) {
      contentNode = (
        <table width={this._getTableWidth()}>
          {this._getHeaderNode()}
          {this._getBodyNode()}
          <tfoot />
        </table>
      );
    }

    return (
      <div
        className={classNames(
          gridClasses,
          'grid-light',
          'disable-text-highlight',
        )}
      >
        {contentNode}
      </div>
    );
  },

  _getTableWidth() {
    const state = this._getCuesheetState();
    const show = state.get('show');

    let width = 0;

    if (show.get('displayItemNumbers')) width += UtilColumnWidths.ItemNumber;
    if (show.get('displayStartTime')) width += UtilColumnWidths.StartTime;
    if (show.get('displayDuration')) width += UtilColumnWidths.Duration;
    if (show.get('displayPresetDuration'))
      width += UtilColumnWidths.PresetDuration;

    state.get('columns').forEach((col) => {
      width += _getColumnWidth(col);
    });

    return width;
  },

  _getHeaderNode() {
    return (
      <thead>
        <GridHeaderRow {...this._getCommonRowProps()} />
      </thead>
    );
  },

  _getCommonRowProps() {
    const state = this._getCuesheetState();

    const columns = state.get('columns'),
      event = this.state.event,
      userSettings = state.get('userSettings'),
      settings = state.get('settings');

    return {
      columns,
      eventId: event.get('_id'),
      teamId: event.get('team'),
      user: this.state.user,
      twentyFourHourClock: event.get('twentyFourHourClock'),
      displayItemNumbers: state.getIn(['show', 'displayItemNumbers']),
      displayItemTitles: state.getIn(['show', 'displayItemTitles']),
      displayItemDescriptions: state.getIn(['show', 'displayItemDescriptions']),
      displayStartTime: state.getIn(['show', 'displayStartTime']),
      displayDuration: state.getIn(['show', 'displayDuration']),
      durationDisplayType: state.getIn(['show', 'durationDisplayType']),
      displayPresetDuration: state.getIn(['show', 'displayPresetDuration']),
      presetDurationDisplayType: state.getIn([
        'show',
        'presetDurationDisplayType',
      ]),
      displayNotes:
        userSettings && !userSettings.getIn(['noteColumn', 'hidden']),
      itemTitleWidth: settings.getIn(['itemTitleColumn', 'width']),
      itemDescriptionWidth: settings.getIn(['itemDescriptionColumn', 'width']),
      noteWidth: userSettings.getIn(['noteColumn', 'width']),
      userSettings,
      settings,
    };
  },

  _getBodyNode() {
    const state = this._getCuesheetState(),
      rows = state.get('rows'),
      userId = state.get('userId'),
      showId = state.get('showId'),
      show = state.get('show'),
      selectedCells = state.get('selectedCells'),
      pastableCells = state.get('pastableCells'),
      pastableCellParams = state.get('pastableCellParams');

    let rowNodes = rows.map((rowSpec, rowIndex) => {
      const item = state.get('rowMap').getIn(rowSpec.get('path'));

      const rowProps = {
        item,
        rowSpec,
        rowId: rowSpec.get('path')[2],
        rowIndex,
        userId,
        showId,
        pastableCells,
        pastableCellParams,
        selectedCells,
      };

      return (
        <GridRow
          displayType={show.get('displayType')}
          gridState={state}
          {...rowProps}
          {...this._getCommonRowProps()}
        />
      );
    });

    return (
      <tbody>
        {rowNodes}
        {this._getButtonRowNode()}
      </tbody>
    );
  },

  _getButtonRowNode() {
    return (
      <tr className="grid-row-last">
        <td>
          <div className="cs-rows-add-btn-container">
            <AddItemButton />
          </div>
        </td>
        <td>&nbsp;</td>
      </tr>
    );
  },

  _getUserState() {
    return this.state.user;
  },

  _getCuesheetState() {
    return this.state.cuesheet || {};
  },

  _emptyCellRenderer() {
    return <span />;
  },
});

/**
 * Grid header row
 */
let GridHeaderRow = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    displayItemNumbers: React.PropTypes.bool,
    displayStartTime: React.PropTypes.bool,
    displayDuration: React.PropTypes.bool,
    displayPresetDuration: React.PropTypes.bool,
    displayItemTitles: React.PropTypes.bool,
    displayItemDescriptions: React.PropTypes.bool,
    displayNotes: React.PropTypes.bool,
    columns: React.PropTypes.array,
  },

  render() {
    let itemNumberColumnNode = null;
    let startTimeColumnNode = null;
    let durationColumnNode = null;
    let presetDurationColumnNode = null;
    let itemDescriptionColumnNode = null;
    let itemTitleColumnNode = null;
    let noteColumnNode = null;

    const {
      displayItemNumbers,
      displayStartTime,
      displayPresetDuration,
      presetDurationDisplayType,
      displayDuration,
      displayItemTitles,
      displayItemDescriptions,
      displayNotes,
      itemTitleWidth,
      itemDescriptionWidth,
      user,
      noteWidth,
    } = this.props;

    if (displayNotes) {
      let currentWidth = noteWidth || ColumnWidthClassNames.Normal;

      noteColumnNode = (
        <HeaderTh
          user={user}
          className={classNames(
            'grid-column-item-note',
            `grid-cell-width-${currentWidth}`,
          )}
          title={NoteColumnHeaderTitle}
          id="item-note"
          Cell={NoteHeaderCell}
          currentWidth={currentWidth}
        />
      );
    }

    if (displayItemNumbers) {
      itemNumberColumnNode = (
        <HeaderTh
          user={user}
          className="grid-column-item-number"
          title="#"
          id="item-number"
        />
      );
    }

    if (displayItemTitles) {
      let currentWidth = itemTitleWidth || ColumnWidthClassNames.Normal;
      itemTitleColumnNode = (
        <HeaderTh
          user={user}
          className={classNames(
            'grid-column-item-title',
            `grid-cell-width-${currentWidth}`,
          )}
          title={ItemColumnHeaderTitle}
          id="item-title"
          Cell={ItemHeaderCell}
          currentWidth={currentWidth}
        />
      );
    }

    if (displayItemDescriptions) {
      let currentWidth = itemDescriptionWidth || ColumnWidthClassNames.Normal;
      itemDescriptionColumnNode = (
        <HeaderTh
          user={user}
          className={classNames(
            'grid-column-item-description',
            `grid-cell-width-${currentWidth}`,
          )}
          title={DescriptionColumnHeaderTitle}
          id="item-description"
          Cell={DescriptionHeaderCell}
          currentWidth={currentWidth}
        />
      );
    }

    if (displayStartTime) {
      startTimeColumnNode = (
        <HeaderTh
          className="grid-column-start-time"
          title="Start Time"
          id="item-start-time"
          user={user}
        />
      );
    }

    if (displayPresetDuration) {
      let title =
        presetDurationDisplayType === TimeDisplayTypes.clockTime
          ? 'Clock Time'
          : 'Preset';
      presetDurationColumnNode = (
        <HeaderTh
          className="grid-column-preset-duration"
          title={title}
          id="item-preset-dur"
          user={user}
        />
      );
    }

    if (displayDuration) {
      durationColumnNode = (
        <HeaderTh
          className="grid-column-duration"
          title="Duration"
          id="item-dur"
          user={user}
        />
      );
    }

    let dataColumnHeaderCellNodes = this._getHeaderCellNodes();

    return (
      <tr>
        <th>{/*Nothing here, it's for the row menu/selection state*/}</th>
        {itemNumberColumnNode}
        {noteColumnNode}
        {startTimeColumnNode}
        {presetDurationColumnNode}
        {durationColumnNode}
        {itemTitleColumnNode}
        {itemDescriptionColumnNode}
        {dataColumnHeaderCellNodes}
        <th className="th-add-column-btn-holder">
          <AddColumnButton />
        </th>
      </tr>
    );
  },

  _getHeaderCellNodes() {
    const columns = this.props.columns;

    return columns.map((column) => {
      let cellClassName =
        'grid-cell-width-' +
        (column.get('width') || ColumnWidthClassNames.Narrow);

      return (
        <th className={cellClassName}>
          <DataHeaderCell
            user={this.props.user}
            column={column}
            isEditing={column.get('editing')}
            isSelected={column.get('selected')}
          />
        </th>
      );
    });
  },
});

const LoadingGridRow = () => {
  return (
    <tr className="grid-row-loading">
      <td colSpan="3">Loading Row..</td>
    </tr>
  );
};

/**
 * Grid Row (data row)
 */
let GridRow = React.createClass({
  mixins: [HighlightCellMixin],

  getInitialState() {
    return { loading: true };
  },

  render() {
    /**
     * Render the first 10 rows, the rest are deferred (see componentDidMount)
     */
    if (this.state.loading && this.props.rowIndex >= 10) {
      return <LoadingGridRow />;
    }

    const { item } = this.props;

    if (item.get('titleView')) return this._getTitleRowNode();

    return this._getDataRowNode();
  },

  componentDidMount() {
    setTimeout(() => {
      this.setState({ loading: false });
      this.forceUpdate(); //this will make us bypass shouldComponentUpdate
    }, 0);
  },

  shouldComponentUpdate(prevProps) {
    /**
     * Find the properties that have changed
     */
    const unequal = [];
    Object.keys(prevProps).forEach((k) => {
      if (prevProps[k] !== this.props[k]) unequal.push(k);
    });

    const _findSelectedCell = (props) => {
      const { rowSpec, selectedCells } = props;
      const rowId = _getRowId(rowSpec);
      return selectedCells.find((cell) => cell.rowId === rowId);
    };

    /**
     * If nothing changed, do not update
     */
    if (!unequal.length) return false;

    /**
     * If only one key changed, and it was selectedCells, check if this row has experienced any changes in its selected cells
     */
    if (unequal.length === 1 && unequal.indexOf('selectedCells') !== -1) {
      if (_findSelectedCell(this.props) || _findSelectedCell(prevProps)) {
        return true;
      }
      return false;
    }

    return true;
  },

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps) {
    /**
     * NOTE: left here intentionally for debugging purposes
     */
    //console.log(prevProps.item === this.props.item)
    //console.log(prevProps.columns === this.props.columns)
    //console.log(prevProps.rowSpec === this.props.rowSpec)
  },

  /**
   * Get the title cell
   */
  _getTitleCellNode() {
    const { item, rowIndex, rowSpec, displayType, settings } = this.props;

    const editing = rowSpec.getIn(['editing', 'type']),
      width = getItemTitleCellWidthName(settings);

    let allowEditingOffViewport = true;

    if (displayType === DisplayTypes.show) {
      allowEditingOffViewport = false;
    }

    let titleFieldNode = (
      <ItemTitle
        width={width}
        placeholder={PlaceholderTitleRowItemSegment}
        rowId={this._getRowId()}
        item={item}
        isCopied={this.isCellCopied(rowIndex, EditableCellTypes.ItemTitle)}
        isSelected={this.isCellSelected(rowIndex, EditableCellTypes.ItemTitle)}
        isEditing={editing === EditableCellTypes.ItemTitle}
        rowIndex={rowIndex}
        allowEditingOffViewport={allowEditingOffViewport}
        displayType={displayType}
        titleFormat={item.get('titleFormat')}
        titleView={item.get('titleView')}
        title={item.get('title')}
      />
    );

    return (
      <td
        className={classNames('grid-title-row-content')}
        colSpan={this._getColumnCount() - 2}
      >
        <h3>{titleFieldNode}</h3>
      </td>
    );
  },

  /**
   * Get the number of columns in the row
   */
  _getColumnCount() {
    const { columns } = this.props;

    let colCount = columns.size;

    if (this.props.displayItemNumbers) colCount++;
    if (this.props.displayStartTime) colCount++;
    if (this.props.displayDuration) colCount++;
    if (this.props.displayPresetDuration) colCount++;
    if (this.props.displayItemTitles) colCount++;
    if (this.props.displayItemDescriptions) colCount++;
    if (this.props.displayNotes) colCount++;

    return colCount + 1; //Add one for the column for the row menu
  },

  _getCommonRowClassConfig() {
    const { rowSpec } = this.props;

    /**
     * Jeremy please change these to be consistent w. the rest of your class names
     */
    return {
      'grid-row-copied': rowSpec.get('copied'),
      'grid-row-selected': rowSpec.get('rowSelected'),
    };
  },

  /**
   * Get the title row node
   */
  _getTitleRowNode() {
    let itemNumberNode = this._getItemNumberCellNode();

    return (
      <tr
        style={Object.assign(
          {},
          this.getGlobalHighlightStyle(),
          this.getPersonalHighlightStyle(),
        )}
        className={classNames(
          this._getCommonRowClassConfig(),
          'grid-title-row',
        )}
      >
        {this._getRowMenuNode()}
        {itemNumberNode}
        {this._getTitleCellNode()}
        <td className="grid-title-row-last">&nbsp;</td>
      </tr>
    );
  },

  /**
   * Get the data row node (titleView === false)
   */
  _getDataRowNode() {
    return (
      <tr
        style={Object.assign(
          {},
          this.getGlobalHighlightStyle(),
          this.getPersonalHighlightStyle(),
        )}
        className={classNames(
          this._getCommonRowClassConfig(),
          'grid-table-row',
        )}
      >
        {this._getRowMenuNode()}
        {this._getItemNumberCellNode()}
        {this._getNoteNode()}
        {this._getStartTimeNode()}
        {this._getPresetDurationNode()}
        {this._getDurationNode()}
        {this._getTitleNode()}
        {this._getDescriptionNode()}
        {this._getDataCellNodes()}
      </tr>
    );
  },

  _getItemLock() {
    const { item } = this.props;

    return (
      <td className="grid-table-row-lock">
        <ItemLock {...this.props} isLocked={item.get('locked')} />
      </td>
    );
  },

  _getRowMenuNode() {
    const { item } = this.props;

    return (
      <td className="grid-table-row-controls">
        <div className="dynamic-control-height">
          <div className="grid-controls-container">
            <ItemLock {...this.props} isLocked={item.get('locked')} />
            <ItemSelectionState
              user={this.props.user}
              rowIndex={this.props.rowIndex}
              isSelected={this.props.rowSpec.get('rowSelected')}
            />
            <RowMenuBar {...this.props} showTrackingOption={false} />
          </div>
        </div>
      </td>
    );
  },

  _getNoteNode() {
    const { displayNotes, noteWidth, displayType, userSettings } = this.props;

    let allowEditingOffViewport = true;

    if (displayType === DisplayTypes.show) {
      allowEditingOffViewport = false;
    }

    if (!displayNotes) return null;

    return (
      <td className={`grid-cell-width-${noteWidth}`}>
        <NoteCell
          {...this.props}
          width={getNoteCellWidthName(userSettings)}
          textAreaStyles={{ position: 'relative' }}
          {...this._getSelectionProps(EditableCellTypes.ItemNote)}
          allowEditingOffViewport={allowEditingOffViewport}
        />
      </td>
    );
  },

  _getTitleNode() {
    const {
      displayItemTitles,
      itemTitleWidth,
      displayType,
      settings,
    } = this.props;

    let allowEditingOffViewport = true;

    if (displayType === DisplayTypes.show) {
      allowEditingOffViewport = false;
    }

    if (!displayItemTitles) return null;

    return (
      <td
        className={`grid-cell-width-${
          itemTitleWidth || ColumnWidthStrings.Normal
        }`}
      >
        <ItemTitle
          width={getItemTitleCellWidthName(settings)}
          placeholder=""
          {...this.props}
          textAreaStyles={{ position: 'relative' }}
          {...this._getSelectionProps(EditableCellTypes.ItemTitle)}
          allowEditingOffViewport={allowEditingOffViewport}
        />
      </td>
    );
  },

  _getSelectionProps(type) {
    const { rowSpec, rowIndex } = this.props;

    const editing = rowSpec.getIn(['editing', 'type']);

    return {
      isSelected: this.isCellSelected(rowIndex, type),
      isEditing: editing === type,
      isCopied: this.isCellCopied(rowIndex, type),
    };
  },

  _getDescriptionNode() {
    const {
      displayItemDescriptions,
      itemDescriptionWidth,
      displayType,
      settings,
    } = this.props;

    let allowEditingOffViewport = true;

    if (displayType === DisplayTypes.show) {
      allowEditingOffViewport = false;
    }

    if (!displayItemDescriptions) return null;
    return (
      <td
        className={`grid-cell-width-${
          itemDescriptionWidth || ColumnWidthStrings.Normal
        }`}
      >
        <ItemDescription
          width={getItemDescriptionCellWidthName(settings)}
          placeholder=""
          {...this.props}
          textAreaStyles={{ position: 'relative' }}
          {...this._getSelectionProps(EditableCellTypes.ItemDescription)}
          allowEditingOffViewport={allowEditingOffViewport}
        />
      </td>
    );
  },

  _getStartTimeNode() {
    if (!this.props.displayStartTime) return null;

    const { rowIndex, gridState, item } = this.props;

    let isSelected = gridState
      ? CuesheetHelper.isCellSelected(
          rowIndex,
          EditableCellTypes.ItemStartTime,
          gridState,
        )
      : false;

    return (
      <td width={UtilColumnWidths.StartTime}>
        <div
          className={classNames({
            'grid-time-selected cs-cell-selected': isSelected,
          })}
        >
          <StartTime
            {...this.props}
            isSelected={isSelected}
            startOn={item.get('startOn')}
            startTimeBackwardAdjusted={item.get('startTimeBackwardAdjusted')}
            displayStartTimeClock={item.get('displayStartTimeClock')}
            startOnInReverse={item.get('startOnInReverse')}
          />
        </div>
      </td>
    );
  },

  _getPresetDurationNode() {
    const {
      item,
      presetDurationDisplayType,
      displayPresetDuration,
      rowIndex,
      gridState,
    } = this.props;

    if (!displayPresetDuration) return null;

    let isSelected = gridState
      ? CuesheetHelper.isCellSelected(
          rowIndex,
          EditableCellTypes.ItemPresetDuration,
          gridState,
        )
      : false;

    return (
      <td width={UtilColumnWidths.PresetDuration}>
        <div
          className={classNames({
            'grid-time-selected cs-cell-selected': isSelected,
          })}
        >
          <PresetDuration
            {...this.props}
            isSelected={isSelected}
            presetDurationDisplayType={presetDurationDisplayType}
            displayPresetDuration={displayPresetDuration}
            value={item.get('presetDurationInSecondsAdjusted')}
          />
        </div>
      </td>
    );
  },

  _getDurationNode() {
    const {
      item,
      durationDisplayType,
      displayDuration,
      rowIndex,
      gridState,
    } = this.props;

    if (!displayDuration) return null;

    let isSelected = gridState
      ? CuesheetHelper.isCellSelected(
          rowIndex,
          EditableCellTypes.ItemDuration,
          gridState,
        )
      : false;

    return (
      <td width={UtilColumnWidths.Duration}>
        <div
          className={classNames({
            'grid-time-selected cs-cell-selected': isSelected,
          })}
        >
          <Duration
            {...this.props}
            displayDuration={displayDuration}
            durationDisplayType={durationDisplayType}
            showRunTimeSuppressionToggle={false}
            isSelected={isSelected}
            value={item.get('durationInSeconds')}
          />
        </div>
      </td>
    );
  },

  /**
   * Get the item number cell
   */
  _getItemNumberCellNode() {
    if (!this.props.displayItemNumbers) return null;

    const { rowSpec, rowIndex, item } = this.props;

    const editing = rowSpec.getIn(['editing', 'type']),
      itemNumber = item.get('numberAdjusted');

    return (
      <td className="grid-row-item-number" width={UtilColumnWidths.ItemNumber}>
        <ItemCellNumber
          {...this.props}
          itemNumber={itemNumber}
          isSelected={this.isCellSelected(
            rowIndex,
            EditableCellTypes.ItemNumber,
          )}
          isEditing={editing === EditableCellTypes.ItemNumber}
        />
      </td>
    );
  },

  /**
   * Get cells for column data
   */
  _getDataCellNodes() {
    const {
      columns,
      rowSpec,
      rowIndex,
      item,
      userId,
      displayType,
    } = this.props;

    let allowEditingOffViewport = true;

    if (displayType === DisplayTypes.show) {
      allowEditingOffViewport = false;
    }

    return columns.map((column) => {
      const cellClassName = `grid-cell-width-${getDataCellWidthName(column)}`;
      const columnId = column.get('_id');
      const isCopied =
          rowSpec.get('copied') || this.isCellCopied(rowIndex, columnId),
        isEditing = rowSpec.getIn(['editing', 'value']) === columnId,
        isSelected = this.isCellSelected(rowIndex, columnId),
        cell = item.getIn(['cells', columnId]),
        width = getDataCellWidthName(column);

      const itemProps = {
        columnId,
        cell,
        rowId: rowSpec.get('path')[2],
        rowIndex,
        item,
        userId,
        isCopied,
        isEditing,
        isSelected,
        width,
        displayType,
      };

      return (
        <td className={cellClassName} width={width}>
          <DataCell
            textAreaStyles={{ position: 'relative' }}
            {...itemProps}
            allowEditingOffViewport={allowEditingOffViewport}
          />
        </td>
      );
    });
  },

  /**
   * Check to see if cell is selected
   *
   * @param rowIndex
   * @param cellIdentifier - This will be the columnId if the cell type
   * is Data or will be the cell type {Item, Note, etc.} if it is not Data type.
   */
  isCellSelected(rowIndex, cellIdentifier) {
    const { selectedCells } = this.props;

    const rowId = this._getRowId();

    return selectedCells && selectedCells.get(`${rowId}_${cellIdentifier}`)
      ? true
      : false;
  },

  /**
   * Check to see if cell is selected
   *
   *
   * NOTE: a very similar function exists in the CuesheetMixin. At some point we should attempt to consolidate these two functions into
   * a new mixin or utility function that's centralized. This was added here because the CuesheetMixin is a mixin for a cuesheet,
   * but this component is a GridRow pure component (no state)
   *
   * @param rowIndex
   * @param cellIdentifier - This will be the columnId if the cell type
   * is Data or will be the cell type {Item, Note, etc.} if it is not Data type.
   */
  isCellCopied(rowIndex, cellIdentifier) {
    const { showId, pastableCellParams, pastableCells } = this.props;

    const rowId = this._getRowId();

    /**
     * Why are we checking showId?
     *
     * This is to prevent copied state to be passed between grids when cells
     * were cut from a different grid. When we duplicate shows and grids they
     * have the same column Id's. That is why we must also check the show Id.
     */
    if (pastableCellParams && showId !== pastableCellParams.get('showId'))
      return false;

    return pastableCells &&
      pastableCells.size > 0 &&
      pastableCells.get(`${rowId}_${cellIdentifier}`)
      ? true
      : false;
  },

  _getRowId() {
    const { rowSpec } = this.props;

    return _getRowId(rowSpec);
  },
});

function _getColumnWidth(col) {
  const widthKey = capitalize(col.get('width') || DefaultColumnWidth);

  return ColumnWidths[widthKey];
}

/* eslint-disable react/prop-types */
const HeaderTh = ({
  className,
  title,
  id,
  Cell = UtilityHeaderCell,
  currentWidth,
  user,
}) => {
  /* eslint-enable react/prop-types */
  return (
    <th className={className}>
      <div>
        <Cell title={title} id={id} currentWidth={currentWidth} user={user} />
      </div>
    </th>
  );
};

/**
 * Get the row Id given a row spec
 * @param rowSpec
 * @returns {null}
 * @private
 */
const _getRowId = (rowSpec) => {
  const rowPath = rowSpec.get('path'),
    rowId = rowPath ? rowPath[2] : null;

  return rowId;
};
